<template>
    <div class="w-100 pb-4">
        <b-nav class="user-panel-nav-tabs">
            <b-nav-item :to="{name: 'AddProducts'}" active-class="active">Add product</b-nav-item>
            <b-nav-item :to="{name: 'IntegrateProducts'}" active-class="active">Marketplaces products</b-nav-item>
        </b-nav>
        <router-view/>
    </div>
</template>

<script>
    export default {
        name: 'MainAddProducts',
    }
</script>



// WEBPACK FOOTER //
// src/components/UserPanel/Pages/Inventory/AddProducts/MainAddProducts.vue